import { CommonConstants } from "../constants/common-constants";

const save = (key: string, value: string): void => {
    const cookieValue = key + "=" + value + ";path=/";
    document.cookie = cookieValue;
};
const remove = (key: string): void => {
    document.cookie = key + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const get = (key: string): string => {
    if (key) {
        const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
        if (match)
            return match[2];
    } else {
        let cookies = document.cookie.split(';');

        let name = key + "=";
        for (let i = 0; i < cookies.length; i++) {
            let c = cookies[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);;
            }
        }
    }
    return "";
}

const saveLogonSession = (logonTokenValue: string): void => {
    try {
        const d = new Date();
        const cookieName = "authenticate_user";
        d.setTime(d.getTime() + (5 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        const cookieValue = cookieName + "=" + logonTokenValue + ";" + expires + ";path=/";
        document.cookie = cookieValue;
    }
    catch (error) {
        console.log(error);
    }

};

const deleteLogonSession = (cookieName?: string): void => {
    if (cookieName) {
        document.cookie = cookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    } else {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }
};
const logOut = () => {
    deleteLogonSession();
    window.location.href = CommonConstants.Routes.Login;
}

const getCookie = (cookieName?: string): string => {
    if (cookieName) {
        const match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        if (match)
            return match[2];
    } else {
        let cookies = document.cookie.split(';');

        let name = CommonConstants.Constants.cookieKey + "=";
        for (let i = 0; i < cookies.length; i++) {
            let c = cookies[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);;
            }
        }
    }
    return "";
}

const checkLogOnSession = (value: string, _cookieName?: string): void => {
    saveLogonSession(value);
}


const CookieHelper = {
    saveLogonSession,
    deleteLogonSession,
    logOut,
    getCookie,
    checkLogOnSession,
    save,
    remove,
    get
}

export default CookieHelper;